import { ArrowRight, Badge, PackageSearch, Tags } from "lucide-react";
import { Link } from "react-router-dom";

export default function CatalogPage() {
  return (
    <div className="p-6 sm:px-[30px] sm:py-7">
      <header className="mb-6">
        <h1 className="text-[22px] font-bold text-slate-900">Catalog</h1>
        <p className="mt-1 text-sm text-slate-500">Manage your master catalog brands, products, and supplier pricing.</p>
      </header>
      <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
        <Link to="/catalog/brands" aria-label="Manage brands"
          className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition hover:border-violet-300 hover:shadow-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-violet-500">
          <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-violet-50 text-violet-600">
            <Badge className="h-6 w-6" aria-hidden="true" />
          </div>
          <h2 className="text-base font-semibold text-slate-900">Brands</h2>
          <p className="mt-2 text-sm text-slate-500">Create, edit, and manage the status of your product brands.</p>
          <span className="mt-5 flex items-center gap-2 text-sm font-semibold text-blue-500">
            Manage brands <ArrowRight className="h-4 w-4" aria-hidden="true" />
          </span>
        </Link>
        <Link to="/catalog/products" aria-label="View products"
          className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition hover:border-violet-300 hover:shadow-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-violet-500">
          <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-violet-50 text-violet-600">
            <PackageSearch className="h-6 w-6" aria-hidden="true" />
          </div>
          <h2 className="text-base font-semibold text-slate-900">Products</h2>
          <p className="mt-2 text-sm text-slate-500">Create, edit, and manage your master products and their reference prices.</p>
          <span className="mt-5 flex items-center gap-2 text-sm font-semibold text-blue-500">
            View products <ArrowRight className="h-4 w-4" aria-hidden="true" />
          </span>
        </Link>
        <Link to="/catalog/supplier-pricing" aria-label="Review supplier pricing"
          className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition hover:border-violet-300 hover:shadow-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-violet-500">
          <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-violet-50 text-violet-600">
            <Tags className="h-6 w-6" aria-hidden="true" />
          </div>
          <h2 className="text-base font-semibold text-slate-900">Supplier Pricing</h2>
          <p className="mt-2 text-sm text-slate-500">Review, add, renew, and deactivate the trade prices suppliers offer on catalog products.</p>
          <span className="mt-5 flex items-center gap-2 text-sm font-semibold text-blue-500">
            Review supplier pricing <ArrowRight className="h-4 w-4" aria-hidden="true" />
          </span>
        </Link>
      </div>
    </div>
  );
}
